import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { VERTICALS } from "@/lib/brand";

export default function Verticals() {
  return (
    <section id="verticals" className="py-24 md:py-32 bg-white" data-testid="verticals-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <p className="text-xs sm:text-sm uppercase tracking-[0.2em] font-semibold text-ember">Industry Verticals</p>
          <h2 className="mt-4 font-heading font-bold tracking-tight text-ink text-3xl sm:text-4xl lg:text-5xl">
            One engine. Built for your industry.
          </h2>
          <p className="mt-5 text-lg text-slatey">
            Specialized agentic solutions, each tuned to the language and workflows of its market — all powered by HaloFlow.
          </p>
        </div>

        <div className="mt-14 grid gap-6 lg:grid-cols-6">
          {VERTICALS.map((v, i) => {
            const isLink = v.url !== "#";
            return (
              <motion.a
                key={v.id}
                href={v.url}
                target={isLink ? "_blank" : undefined}
                rel="noreferrer"
                initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                transition={{ duration: 0.45, delay: (i % 3) * 0.08 }}
                data-testid={`vertical-card-${v.id}`}
                className={`group flex flex-col justify-between border border-slate-200 bg-white p-8 hover:border-ink transition-colors ${v.span}`}>
                <div>
                  <div className="flex items-start justify-between">
                    <span className="text-xs uppercase tracking-[0.18em] font-semibold text-ember">{v.tag}</span>
                    <span className="text-xs font-mono text-slate-300">0{i + 1}</span>
                  </div>
                  <h3 className="mt-4 font-heading font-bold text-ink text-xl">{v.name}</h3>
                  {v.logo && (
                    <img src={v.logo} alt={`${v.name} logo`} className="mt-4 h-12 w-auto object-contain" />
                  )}
                  <p className="mt-3 text-sm text-slatey leading-relaxed">{v.desc}</p>
                </div>
                <span className="mt-7 inline-flex items-center gap-1.5 text-sm font-semibold text-ink group-hover:text-ember transition-colors">
                  Learn More
                  <ArrowUpRight className="h-4 w-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                </span>
              </motion.a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
